export const RECEIVE_COLLECTIONS = "adminCollection/RECEIVE_COLLECTIONS";

export const SET_COLLECTION_EDITING = "adminCollection/SET_COLLECTION_EDITING";
export const EDIT_COLLECTION_PROP = "adminCollection/EDIT_COLLECTION_PROP";
export const EDIT_COLLECTION_BY_ID_PROP = "adminCollection/EDIT_COLLECTION_BY_ID_PROP";
export const UPDATE_COLLECTION = "adminCollection/UPDATE_COLLECTION";
export const DELETE_COLLECTION = "adminCollection/DELETE_COLLECTION";
export const REORDER_COLLECTIONS = "adminCollection/REORDER_COLLECTIONS";
